/**
 * Тема оформления. Три состояния, как в Android-версии (`ThemeMode` в `core/settings`):
 * системная, светлая, тёмная.
 *
 * Выбор пользователя ставится атрибутом `data-theme` на корне документа — по нему
 * tokens.css перебивает системную настройку. Динамических цветов из обоев
 * (Material You) нет и не планируется: у продукта должно быть своё лицо.
 */
export type ThemeMode = 'system' | 'light' | 'dark';

export function applyThemeMode(mode: ThemeMode) {
  const root = document.documentElement;

  if (mode === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', mode);
}
